import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-templates-labels',
  templateUrl: './email-templates-labels.component.html',
  styleUrls: ['./email-templates-labels.component.scss']
})
export class EmailTemplatesLabelsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
